// extracted by mini-css-extract-plugin
export var content = "Layout-module--content--b57ad";
export var inner = "Layout-module--inner--2c771";
export var main = "Layout-module--main--fc511";
export var root = "Layout-module--root--d7870";
export var sidebar = "Layout-module--sidebar--c5dd2";